import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import downloadIcon from '../../assets/downloadIcon.png'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';

const ProgramManagerPartnerGrid = (props) => {

  const [expandedPartner, setExpandedPartner] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [resourcesData, setResourcesData] = useState([]);


  const gridRef = useRef();
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  useEffect(() => {
    const selectedManager = props.selectedProgramManager?.value
    setExpandedPartner(null);

    if (selectedManager && props.partnerDataProgramManager) {
      const partnerData = props.partnerDataProgramManager
      setRowData(partnerData);
    } else {
      setRowData([]);
    }
  }, [props.selectedProgramManager, props.partnerDataProgramManager])

  useEffect(() => {
    setResourcesData([])

    if (props.selectedPartnerName && props.resourceDataSelectedPartner) {
      setResourcesData(props.resourceDataSelectedPartner);
    } else {
      setResourcesData([]);
    }
  }, [props.selectedPartnerName, props.resourceDataSelectedPartner])

  useEffect(() => {
    setResourcesData(props.resourceDataSelectedPartner);
  }, [resourcesData]);

  const handlePartnerClick = (partner) => {
    setResourcesData([])
    props.setResourceDataSelectedPartner([])
    const partnerName = partner.sEntryPoint;
    props.setSelectedPartnerName(partner.sEntryPoint)
    setExpandedPartner(expandedPartner === partnerName ? null : partnerName);
    if (expandedPartner !== partnerName) {
      props.getResourceDataForSelectedPartner(props.selectedProgramManager.value, partnerName)
      setResourcesData(props.resourceDataSelectedPartner);
    } else {
      setResourcesData([]);
    }

  };

  const footerRow = {
    sEntryPoint: "Total",
    FTU_Count: "Total" + " : " + " " + rowData?.reduce((total, row) => total + row.FTU_Count, 0),
    EU_Count: "Total" + " : " + " " + rowData?.reduce((total, row) => total + row.EU_Count, 0),
  };

  const subfooterRow = {
    sResourceDisplayName: "Total",
    FTU_Count: "Total" + " : " + " " + resourcesData?.reduce((total, row) => total + row.FTU_Count, 0),
    EU_Count: "Total" + " : " + " " + resourcesData?.reduce((total, row) => total + row.EU_Count, 0),
  };

  const columnDefs = [
    {
      headerName: 'Partner Name',
      field: 'sEntryPoint',
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
      cellRenderer: params => {
        let resourceName = params.value;
        if (resourceName === "null") {
          resourceName = "Not Provided";
        }
        if (resourceName === "Total") {
          return <div style={{ textAlign: "right", display: 'none' }}>{resourceName}</div>;
        } else {
          return resourceName;
        }
      },
      width: 350,
    },
    {
      headerName: 'FTC',
      field: 'FTU_Count',
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
    {
      headerName: 'EU', field: 'EU_Count',
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
  ];

  const subColumnDefs = [
    {
      headerName: "Resource Name", field: "sResourceDisplayName",
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
      cellRenderer: params => {
        let resourceName = params.value;
        if (resourceName === "null") {
          resourceName = "Not Provided";
        }
        if (resourceName === "Total") {
          return <div style={{ textAlign: "right", display: 'none' }}>{resourceName}</div>;
        } else {
          return resourceName;
        }
      },
      width: 350,
    },
    {
      headerName: "FTC", field: "FTU_Count",
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
    {
      headerName: "EU", field: "EU_Count",
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
  ]

  const gridOptions = useMemo(() => ({
    suppressScrollOnNewData: true,
  }), []);

  const overlayNoRowsTemplate = rowData.length === 1 && rowData[0].sEntryPoint === "No Data Available"
    ? '<span class="ag-overlay-no-rows-center">No data available</span>'
    : '<span class="ag-overlay-no-rows-center">loading...</span>';


  return (
    <div className="mb-5">
      {
        props.selectedProgramManager?.value &&
        <div>
          {/* Program Manager Dropdown */}
          <h3
            className="spled-colored-label"
            style={{
              fontSize: "20px",
              marginRight: 10,
              margin: 10
            }}
          >
            Partner Data for Program Manager
          </h3>

          {/* Grid Display */}
          <div style={{ height: "50vh", boxSizing: "border-box" }}>
            <div style={gridStyle} className="ag-theme-material">
              <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                rowSelection="single"
                onRowClicked={(event) => handlePartnerClick(event.data)}
                pinnedBottomRowData={[footerRow]}
                overlayNoRowsTemplate={overlayNoRowsTemplate}
                rowClassRules={{
                  "total-row": 'data.sEntryPoint === "Total"',
                }}
              />
            </div>
          </div>

          {/* Detail View */}
          {expandedPartner && (
            <div className="mt-3" style={{ height: "50vh", boxSizing: "border-box" }}>
              <div className="ag-theme-material" style={gridStyle}>
                <h2
                  className="spled-colored-label"
                  style={{
                    fontSize: "20px",
                    marginRight: 10,
                    margin: 10
                  }}>Resources for {expandedPartner}</h2>
                <AgGridReact
                  columnDefs={subColumnDefs}
                  rowData={resourcesData || []}
                  pinnedBottomRowData={[subfooterRow]}
                  overlayNoRowsTemplate={
                    '<span class="ag-overlay-loading-center">loading...</span>'
                  }
                  rowClassRules={{
                    "total-row": 'data.sResourceDisplayName === "Total"',
                  }}
                />
              </div>
            </div>
          )}
        </div>
      }
    </div>

  );
};


export default ProgramManagerPartnerGrid

